module.exports = __webpack_public_path__ + "661e1a50ccd11060cedfbe7d05ecd708.png";